import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import Landing from "./pages/Landing";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import Admin from "./pages/Admin";
import ArticlePage from "./pages/ArticlePage";
import ProgramPage from "./pages/ProgramPage";
import PathPage from "./pages/PathPage";
import AboutPage from "./pages/AboutPage";
import PhasePage from "./pages/PhasePage";

function App() {
    return (
        <BrowserRouter>
            <SmoothScroll>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/blog/:id" element={<ArticlePage />} />
                    <Route path="/programma/:slug" element={<ProgramPage />} />
                    <Route path="/percorso/:slug" element={<PathPage />} />
                    <Route path="/fase/:slug" element={<PhasePage />} />
                    <Route path="/chi-sono" element={<AboutPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/cookie-policy" element={<CookiePolicy />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </SmoothScroll>
            <Toaster position="top-center" richColors />
        </BrowserRouter>
    );
}

export default App;
